import React from 'react';
import { useEmployeeBranchInputQuery } from '../../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../../dum';
import { IEmployee } from '../../employee-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function BranchInput() {
    const inputName: keyof IEmployee = 'branch_id';

    const { data } = useEmployeeBranchInputQuery();

    const options = data?.getBranches || [];

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={inputName}
            label={shortLabel(FIELD_LABELS.branch_id)}
            options={options}
        />
    );
}
